import type { ActingParty, PersonInvolvement } from "../types/involvement.js";

/**
 * An involvement is the party's when it names the organisation being acted for,
 * or names the user acting on behalf of the organisation being acted for. The
 * second condition is the rule that authority comes from the session context
 * doing its ordinary job: a user who has left that organisation has no
 * membership there, so their involvement conveys nothing without anything
 * ending it.
 */
export const isInvolvementHeldBy = (
  involvement: Pick<PersonInvolvement, "party">,
  party: Pick<ActingParty, "userId" | "organisationId">,
): boolean =>
  involvement.party.kind === "organisation"
    ? involvement.party.organisationId === party.organisationId
    : involvement.party.userId === party.userId &&
      involvement.party.onBehalfOfOrganisationId === party.organisationId;
